import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { BTN_DARK_THEME, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON, Button, } from '@yme/atoms/button';
import { ShowMore } from '@yme/atoms/show-more';
import { useIsMount, useWindowSize } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel1, HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
export function ContentDefaultView(props) {
    const { 
    // Provided from AEM
    title, subtitle, description, 
    // Extra props
    isRightToLeft, onClickHandler, learnMoreLabel, scrollToComponentId, 
    // labels for ShowMore component - only for tablet view
    showLessLabel, showMoreLabel, } = props;
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    const isMount = useIsMount();
    return (React.createElement(FlexWrapper, { flexDirection: "column", justifyContent: "end", height: "100%" },
        subtitle && (React.createElement(FlexWrapper, { mb: "4px" },
            React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, subtitle))),
        React.createElement(FlexWrapper, null,
            React.createElement(HeadingLevel1, { color: colorCoreWhite1000 }, title)),
        !isMobileView && description && (React.createElement(FlexWrapper, { mt: "16px" }, !isInfiniteDesktopView && !isMount ? (React.createElement(ShowMore, { maxLinesCount: 3, labelShowLess: showLessLabel, labelShowMore: showMoreLabel, bottomIndent: "0", wrapper: RegularTextLevel3, textColor: colorCoreWhite1000, buttonColor: colorCoreWhite1000 }, description)) : (React.createElement(RegularTextLevel3, { color: colorCoreWhite1000 }, description)))),
        !isMobileView && learnMoreLabel && scrollToComponentId && (React.createElement(FlexWrapper, { mt: "24px" },
            React.createElement(FlexWrapper, { flexDirection: "row" },
                React.createElement(Button, { width: "unset", iconRotate: 90, buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, isRightToLeft: isRightToLeft, label: learnMoreLabel, colorSchema: BTN_DARK_THEME, onClick: onClickHandler }))))));
}
ContentDefaultView.displayName = 'ContentDefaultView_Component';
